/* eslint-disable */

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(require("froala-editor")) : "function" == typeof define && define.amd ? define(["froala-editor"], t) : t(e.FroalaEditor);
}(this, function (s) {
  "use strict";
  s = s && s.hasOwnProperty("default") ? s.default : s, Object.assign(s.DEFAULTS, {wordCounterMax: -1, wordCounterCount: true}), s.PLUGINS.wordCounter = function (o) {
    var r, t = o.$;
    function n() {
      var e = o.el.innerText.toString();
      e = (e = (e = (e = (e = (e = (e = (e = e.replace(/(^\s*)|(\s*$)/gi, " ")).replace(/\u00a0/g, " ")).replace(/[ ]{2,}/gi, " ")).replace(/\n /, "\n")).replace(/[\u200A\u200C-\u200D\uFEFF\u202F\u2000-\u2009\u205F\u3000\u1680\u00A0\u0020]/g, " ")).replace(/[\u200B']/g, "")).replace(/\t+/g, " ")).replace(/[^\w\s]|_/g, ' ').split(" ").join("\n");
      var t = o.$el.find(".fr-pagebreak"), r = e.split(/\r?\n/), n = 0;
      return r.forEach(function (e) {
        0 < (e = e.replace(/\s/g, "")).length && n++;
      }), n - 2 * t.length;
    }
    function e(e) {
      if (o.opts.wordCounterMax < 0) return true;
      if (n() < o.opts.wordCounterMax) return true;
      var t = e.which;
      return !(!o.keys.ctrlKey(e) && o.keys.isCharacter(t) || t === s.KEYCODE.IME) || (e.preventDefault(), e.stopPropagation(), o.events.trigger("wordCounter.exceeded"), false);
    }
    function u() {
      if (o.opts.wordCounterCount) {
        var e = n() + (0 < o.opts.wordCounterMax ? "/" + o.opts.wordCounterMax : "");
        r.text("".concat(e, ' ', e === "1" ? o.language.translate("Word") : o.language.translate("Words"))), o.opts.toolbarBottom && r.css("margin-bottom", o.$tb.outerHeight(true));
        var t = o.$wp.get(0).offsetWidth - o.$wp.get(0).clientWidth;
        0 <= t && ("rtl" == o.opts.direction ? r.css("margin-left", t) : r.css("margin-right", t));
      }
    }
    function a(e) {
      return o.opts.wordCounterMax < 0 ? e : t("<div>").html(e).text().split(" ").length + n() <= o.opts.wordCounterMax ? e : (o.events.trigger("wordCounter.exceeded"), "");
    }
    return {_init: function i() {
      return !!o.$wp && !!o.opts.wordCounterCount && ((r = t(document.createElement("span")).attr("class", "fr-counter fr-wCounter")).css("bottom", o.$wp.css("border-bottom-width")), o.$second_tb ? o.$second_tb.append(r) : o.$wp.append(r), o.events.on("keydown", e, true), o.events.on("paste.afterCleanup", a), o.events.on("keyup contentChanged input", function () {
        o.events.trigger("wordCounter.update");
      }), o.events.on("wordCounter.update", u), o.events.trigger("wordCounter.update"), void o.events.on("destroy", function () {
        t(o.o_win).off("resize.char".concat(o.id)), r.removeData().remove(), r = null;
      }));
    }, wordCount: n};
  };
});

